import { useSyncExternalStore } from 'react';
import { OnlineStatus } from './types';

function getSnapshot(): OnlineStatus {
  if (!navigator)
    return OnlineStatus.Unknown;

    return navigator.onLine ? OnlineStatus.Online : OnlineStatus.Offline;
}

function getServerSnapshot(): OnlineStatus {
  return OnlineStatus.Online;
}

function subscribe(callback: () => void) {

  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);

  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
  
}

export function useOnlineStatus(): OnlineStatus {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}